import { Box, Unstable_Grid2 as Grid } from '@mui/material';

import {
  Typography,
  KeyboardDateTimePicker,
  Select,
  TextField,
  Divider,
} from '@occc-app/design-system';
import { CompletionRange } from '@occc/graphql';
import { LocationMultipleSelectField } from '@occc-app/routes/Location/components/LocationSelect/LocationMultipleSelectField';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { sanitizePhoneNumberForInput } from '@occc/utils-phone-number';
import { TransactionsFilterFormValues } from '../transactions-filter-form.types';
import {
  fraudCheckStatusFilterOptions,
  transactionCompletedAtOptions,
  transactionStatusFilterOptions,
} from '../transactions-filter-form.constants';

type TransactionsFilterFormContentProps = {
  shouldShowFraudCheckStatusFilter?: boolean;
  values: TransactionsFilterFormValues;
};

export const TransactionsFilterFormContent = ({
  shouldShowFraudCheckStatusFilter,
  values,
}: TransactionsFilterFormContentProps) => {
  return (
    <Box p={3}>
      <Typography variant='h6'>Filter Transactions</Typography>

      <Grid container columnSpacing={3} rowSpacing={3} pt={3}>
        <Grid xs={12}>
          <LocationMultipleSelectField
            inputProps={{
              margin: 'none',
            }}
            name={'locations' satisfies keyof TransactionsFilterFormValues}
            label='Locations'
          />
        </Grid>

        <Grid xs={12}>
          <Divider />
        </Grid>

        <Grid xs={12}>
          <TextField
            name={'phoneNumber' satisfies keyof TransactionsFilterFormValues}
            label='Phone Number'
            fieldProps={{
              margin: 'none',
              format: sanitizePhoneNumberForInput,
              parse: sanitizePhoneNumberForInput,
            }}
          />
        </Grid>

        <Grid xs={12}>
          <Divider />
        </Grid>

        <Grid xs={12} md={6}>
          <TextField
            name={'amountMin' satisfies keyof TransactionsFilterFormValues}
            label='Min $ Amount'
            type='number'
            fieldProps={{
              parse: parseNumber,
              margin: 'none',
            }}
          />
        </Grid>

        <Grid xs={12} md={6}>
          <TextField
            name={'amountMax' satisfies keyof TransactionsFilterFormValues}
            label='Max $ Amount'
            type='number'
            fieldProps={{
              parse: parseNumber,
              margin: 'none',
            }}
          />
        </Grid>

        <Grid xs={12}>
          <Select
            name={'transactionStatus' satisfies keyof TransactionsFilterFormValues}
            label='Transaction Status'
            data={transactionStatusFilterOptions}
          />
        </Grid>

        {shouldShowFraudCheckStatusFilter && (
          <Grid xs={12}>
            <Select
              name={'fraudCheckStatus' satisfies keyof TransactionsFilterFormValues}
              label='Fraud Status'
              data={fraudCheckStatusFilterOptions}
            />
          </Grid>
        )}

        <Grid xs={12}>
          <Select
            name={'transactionCompletedAt' satisfies keyof TransactionsFilterFormValues}
            label='Transaction Completed At'
            data={transactionCompletedAtOptions}
          />
        </Grid>

        <Grid xs={12} sm={6}>
          <KeyboardDateTimePicker
            label='Start Date'
            name={'startDate' satisfies keyof TransactionsFilterFormValues}
            disabled={values.transactionCompletedAt !== CompletionRange.CustomRange}
          />
        </Grid>

        <Grid xs={12} sm={6}>
          <KeyboardDateTimePicker
            label='End Date'
            name={'endDate' satisfies keyof TransactionsFilterFormValues}
            disabled={values.transactionCompletedAt !== CompletionRange.CustomRange}
            minDate={values.startDate ?? undefined}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
